<template>
	<nav class="topnav navbar navbar-expand-lg navbar-light fixed-top">
		<div class="container">
			<a class="navbar-brand" href="/"><strong><img src="@/assets/img/logo.png"
						style="height: 2rem; width: 2rem; margin-right: 0.5rem" />重庆旌祺邦电气有限公司</strong></a>
			<button class="navbar-toggler collapsed" type="button" @click="showMenu" data-toggle="collapse"
				data-target="#navbarColor02" aria-controls="navbarColor02" aria-expanded="false"
				aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="navbar-collapse collapse" id="navbarColor02" style="">
				<ul class="navbar-nav mr-auto d-flex align-items-center" style="flex: 1; justify-content: flex-end;">
					<li class="nav-item">
						<router-link class="nav-link" :class="activeName=='0'&&'active'" to="/">首页 </router-link>
					</li>
					<li class="nav-item">
						<router-link class="nav-link" :class="activeName=='1'&&'active'" to="/about">关于我们</router-link>
					</li>
					<li class="nav-item">
						<router-link class="nav-link" :class="activeName=='2'&&'active'" to="/products">产品展示</router-link>
					</li>
					<li class="nav-item">
						<router-link class="nav-link" :class="activeName=='3'&&'active'" to="/case">项目业绩</router-link>
					</li>
					<li class="nav-item">
						<router-link class="nav-link" :class="activeName=='4'&&'active'" to="/honor">资质证书</router-link>
					</li>
					<li class="nav-item">
						<router-link class="nav-link" :class="activeName=='5'&&'active'" to="/news">新闻中心</router-link>
					</li>
					<li class="nav-item">
						<router-link class="nav-link" :class="activeName=='6'&&'active'" to="/contact">联系我们</router-link>
					</li>
				</ul>
				<!-- <ul class="navbar-nav ml-auto d-flex align-items-center">
			<li class="nav-item highlight">
			<a class="nav-link" href="https://www.wowthemes.net/mundana-free-html-bootstrap-template/">Get this Theme</a>
			</li>
		</ul> -->
			</div>
		</div>
	</nav>
</template>

<script>
	export default {
		data() {
			return {
				activeName: '0',
				isShow: false
			}
		},
		methods: {
			showMenu() {
				this.isShow = !this.isShow;
				if(this.isShow) {
					// console.log($)
					// console.log()
					document.getElementById('navbarColor02').style.display = 'block'
				} else {
					document.getElementById('navbarColor02').style.display = 'none'
				}
			}
		},
		mounted() {
			const path = this.$route.path;
			if(path == '/') {
				this.activeName = '0'
			}
			if(path == '/about') {
				this.activeName = '1'
			}
			if(path == '/products') {
				this.activeName = '2'
			}
			if(path == '/product-detail') {
				this.activeName = '2'
			}
			if(path == '/case' || path == '/case-detail') {
				this.activeName = '3'
			}
			if(path == '/honor') {
				this.activeName = '4'
			}
			if(path == '/news') {
				this.activeName = '5'
			}
			if(path == '/news-detail') {
				this.activeName = '5'
			}
			if(path == '/contact') {
				this.activeName = '6'
			}
		},
	}
</script>

<style>
	.navbar-brand {
		width: 16.875rem;
	}
	.navbar-light .navbar-nav .nav-link {
		white-space: nowrap;
	}
</style>
